import { Box, Typography } from '@mui/material';
import { PACKAGE_LEVEL } from '@src/constants/package';
import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const PackagesComparisonContainer = styled.div`
  position: relative;
  padding-top: 80px;
  padding-bottom: 0px;
  background-color: white;
  max-width: 100%;

  @media (max-width: 640px) {
    max-width: 100%;
    border-radius: 0;
    width: 100%;
    padding-top: 16px;
  }

  margin-bottom: 24px;

  .button-start {
    font-weight: bold;
    border-radius: 8px;
    border: 0.5px solid ${COLOR.borderDropdown};
    color: ${COLOR.darkBlue};
    text-transform: none;
    background-color: white;
    height: 40px;
    min-height: 40px;
    padding: 4px 8px;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 500;
    margin-top: 8px;
  }

  .button-highlight {
    background: ${COLOR.primary} !important;
  }

  .button-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const YearlyContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const HeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 700,
  fontSize: '24px',
  padding: '0 16px',
  color: '#1C1C1E',
  zIndex: 10,
  backgroundColor: 'white',
  height: '64px',
  '@media (min-width: 640px)': {
    justifyContent: 'space-between',
    fontSize: '32px',
    height: '88px',
  },
});

export const Spacer = styled('div')({
  width: '104px',
  display: 'none',
  '@media (min-width: 640px)': {
    display: 'block',
  },
});

export const ButtonContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
});

export const ScrollButton = styled('button')(({ disabled }) => ({
  padding: '8px',
  border: '1px solid #1E164E29',
  borderRadius: '12px',
  transition: 'background-color 0.2s',
  height: '40px',
  width: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  color: '#1E164E',
  opacity: disabled ? 0.5 : 1,
  cursor: disabled ? 'not-allowed' : 'pointer',
  '&:hover': {
    backgroundColor: disabled ? 'white' : '#f3f4f6',
  },
}));

export const PackageContainer = styled(Box)(({ level }) => {
  let background = '#ffffff';

  if (level === PACKAGE_LEVEL.CUSTOM) {
    background =
      'radial-gradient(100% 100% at 100% 100%, rgba(86, 62, 250, 0.08) 0%, rgba(86, 62, 250, 0) 100%)';
  } else if (level === PACKAGE_LEVEL.SPECIAL) {
    background =
      'radial-gradient(100% 100% at 100% 100%, rgba(255, 238, 0, 0.105) 0%, rgba(255, 149, 0, 0) 100%)';
  }

  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '20px',
    height: '126px',
    background,
  };
});

export const PriceText = styled(Typography)(({ isVipPkg }) => ({
  fontSize: '20px',
  fontWeight: 700,
  textAlign: 'left',
  color: '#1E164E',
  lineHeight: '28px',
  display: 'flex',
  alignItems: 'center',
  marginTop: isVipPkg ? '3px' : '0',
}));

export const CurrencySign = styled('span')(({ $isVietNam }) => ({
  fontWeight: 510,
  fontSize: '16px',
  textDecoration: $isVietNam ? 'underline' : 'none',
}));

export const MobileActionContainer = styled.div`
  background-color: white;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  position: sticky;
  bottom: 0px;
  left: 0;
  right: 0;
  box-shadow: 0px -4px 16px 0px #00000014;
  z-index: 10;

  @supports (-webkit-touch-callout: none) {
    /* Safari-specific styles */
    @media (max-width: 640px) {
      bottom: calc(env(safe-area-inset-bottom));
    }
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 60px;
    height: 64px;
    pointer-events: none;
    z-index: 1;
  }

  &::after {
    right: 0;
    background: linear-gradient(
      to left,
      ${(props) =>
        props.isScrolledToEnd || props.isMonthPackage
          ? 'transparent'
          : 'white'},
      transparent
    );
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  overflow-x: auto;
`;

export const TabButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  height: 40px;
  white-space: nowrap;
  flex: 1;
  transition: all 0.2s;
  background-color: ${(props) => (props.isActive ? '#1E164E' : 'transparent')};
  color: ${(props) => (props.isActive ? 'white' : '#1C1C1EA3')};
  border: none;
  outline: none;
`;
